export default "__VITE_ASSET__BC$yBLqJ__"